/* eslint-disable import/no-cycle */
import Vue from 'vue';
import VueRouter from 'vue-router';
import { authGuard, loginGuard, roleGuard } from './guards';
import Login from '../views/Login';
import store from '../store/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: { name: 'pages' },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: loginGuard,
  },
  {
    path: '/profile',
    name: 'profile',
    // route level code-splitting
    // this generates a separate chunk (profile.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // webpackChunkName says what will the import look like in the network tab.
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile'),
    beforeEnter: authGuard,
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/users/Users'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin'] },
    children: [
      {
        path: 'create',
        name: 'createUser',
        component: () => import(/* webpackChunkName: "createUser" */ '../views/users/CreateUser'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin'] },
      },
      {
        path: ':id/edit',
        name: 'editUser',
        component: () => import(/* webpackChunkName: "editUser" */ '../views/users/EditUser'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin'] },
      },
    ],
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import(/* webpackChunkName: "contacts" */ '../views/contacts/Contacts'),
    beforeEnter: authGuard,
    children: [
      // {
      //   path: 'create',
      //   name: 'createContact',
      //   component: () =>
      //     import(/* webpackChunkName: "createContact" */ '../views/contacts/CreateContact'),
      //   beforeEnter: authGuard,
      // },
      {
        path: ':id/edit',
        name: 'editContact',
        component: () =>
          import(/* webpackChunkName: "editContact" */ '../views/contacts/EditContact'),
        beforeEnter: authGuard,
      },
      {
        path: 'images/:url',
        name: 'contacts/image',
        component: () =>
          import(/* webpackChunkName: "images" */ '../components/base/BaseImageViewer'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/patient-story',
    name: 'patientStory',
    component: () =>
      import(/* webpackChunkName: "patientStory" */ '../views/patient-story/PatientStory'),
    beforeEnter: authGuard,
    children: [
      {
        path: ':id/edit',
        name: 'editPatientStory',
        component: () =>
          import(
            /* webpackChunkName: "editPatientStory" */ '../views/patient-story/EditPatientStory'
          ),
        beforeEnter: authGuard,
      },
      {
        path: 'images/:url',
        name: 'patientStory/images',
        component: () =>
          import(/* webpackChunkName: "images" */ '../components/base/BaseImageViewer'),
        beforeEnter: authGuard,
      },
      {
        path: 'text/:id',
        name: 'patientStory/text',
        component: () =>
          import(/* webpackChunkName: "text" */ '../views/patient-story/ViewPatientStoryText'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/pages',
    name: 'pages',
    component: () => import(/* webpackChunkName: "pages" */ '../views/pages/Pages'),
    beforeEnter: authGuard,
    children: [
      {
        path: ':id/edit',
        name: 'editPages',
        component: () => import(/* webpackChunkName: "editPages" */ '../views/pages/EditPages'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/publications',
    name: 'publications',
    component: () =>
      import(/* webpackChunkName: "publications" */ '../views/publications/Publications'),
    beforeEnter: authGuard,
    children: [
      {
        path: ':id/edit',
        name: 'editPublication',
        component: () =>
          import(
            /* webpackChunkName: "editPublications" */ '../views/publications/EditPublications'
          ),
        beforeEnter: authGuard,
      },
      {
        path: 'images/:url',
        name: 'publications/images',
        component: () =>
          import(/* webpackChunkName: "images" */ '../components/base/BaseImageViewer'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/activity-reports',
    name: 'activityReports',
    component: () =>
      import(/* webpackChunkName: "activityReports" */ '../views/activity-reports/ActivityReports'),
    beforeEnter: authGuard,
    children: [
      {
        path: ':id/edit',
        name: 'editActivityReport',
        component: () =>
          import(
            /* webpackChunkName: "editActivityReports" */ '../views/activity-reports/EditActivityReport'
          ),
        beforeEnter: authGuard,
      },
      {
        path: 'files/:id',
        name: 'activityReport/files',
        component: () => import(/* webpackChunkName: "files" */ '../views/files/ViewFiles'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/awards',
    name: 'awards',
    component: () => import(/* webpackChunkName: "awards" */ '../views/awards/Awards'),
    beforeEnter: authGuard,
    children: [
      {
        path: ':id/edit',
        name: 'editAward',
        component: () => import(/* webpackChunkName: "editAward" */ '../views/awards/EditAward'),
        beforeEnter: authGuard,
      },
      {
        path: 'text/:id',
        name: 'awards/text',
        component: () => import(/* webpackChunkName: "text" */ '../views/awards/ViewAwardsText'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/articles',
    name: 'articles',
    component: () => import(/* webpackChunkName: "articles" */ '../views/articles/Articles'),
    beforeEnter: authGuard,
    children: [
      {
        path: ':id/edit',
        name: 'editArticle',
        component: () =>
          import(/* webpackChunkName: "editArticle" */ '../views/articles/EditArticle'),
        beforeEnter: authGuard,
      },
      {
        path: ':id/images',
        name: 'articles/images',
        component: () => import(/* webpackChunkName: "images" */ '../views/articles/ArticleImages'),
        beforeEnter: authGuard,
      },
      {
        path: 'text/:id',
        name: 'articles/text',
        component: () => import(/* webpackChunkName: "text" */ '../views/articles/ViewArticleText'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/upload-images',
    name: 'uploadImages',
    component: () => import(/* webpackChunkName: "uploadImages" */ '../views/images/UploadImages'),
    beforeEnter: authGuard,
    children: [
      {
        path: 'images/:url',
        name: 'uploadImages/images',
        component: () =>
          import(/* webpackChunkName: "images" */ '../components/base/BaseImageViewer'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/metatags',
    name: 'metatags',
    component: () => import(/* webpackChunkName: "metatags" */ '@/views/metatags/Metatags'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin'] },
    children: [],
  },
  {
    path: '/popup-banners',
    name: 'popupBanners',
    component: () =>
      import(/* webpackChunkName: "popupBanners" */ '../views/popup-banners/PopupBanners'),
    beforeEnter: authGuard,
    children: [
      {
        path: 'create',
        name: 'createPopupBanner',
        component: () =>
          import(
            /* webpackChunkName: "createPopupBanner" */ '../views/popup-banners/CreatePopupBanner'
          ),
        beforeEnter: authGuard,
      },
      {
        path: ':id/edit',
        name: 'editPopupBanner',
        component: () =>
          import(
            /* webpackChunkName: "editPopupBanner" */ '../views/popup-banners/EditPopupBanner'
          ),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: process.env.VUE_APP_HTML_HISTORY_MODE ? 'history' : '',
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.isPublic) {
    next();
    return;
  }
  if (!store.getters.accessToken) {
    await store.dispatch('auth/tryAutoLogin');
  }
  next();
});

export default router;
